import React from 'react';
import { Link } from 'react-router-dom';
import './NavigationLink.scss';

const NavigationLink = ({href, children, active, highlight, editClass, isOpen }) => {
    return (
    <Link className={`NavigationLink ${active ? 'active' : ''} ${highlight ? 'highlight' : ''} ${editClass ?  "editClass" : ''} ${isOpen ? 'open' : ''}`} to={href}>
        {children}
    </Link>);
}

export default NavigationLink;
